import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn('h-4 w-4 animate-spin', className)} aria-label="Loading" />;
}

export function PageSpinner() {
  return (
    <div className="flex h-full min-h-[40dvh] w-full items-center justify-center">
      <Spinner className="h-6 w-6 text-(--color-primary)" />
    </div>
  );
}
